import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class OrderService extends Service {
    constructor() {
        super();
        this.baseURL = 'dispatchio/order';
    }

    async getOpenOrders(scope) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/newOrders/" + scope, {
            headers: { 'Content-Type': 'application/json', 'X-Softrame-BranchId': localStorage.getItem("merchantBranchId") },
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async acceptOrder(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/accept/id/" + id, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async preparingOrder(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/preparing/id/" + id, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async readyOrder(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/ready/id/" + id, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async deliverOrder(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/deliver/id/" + id, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async dispatchOrder(id, driverId) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/dispatch/id/" + id + "/driverId/" + driverId, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async declineOrder(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/decline/id/" + id, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async closeOrder(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/close/id/" + id, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async printReceipt(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/printreceipt/id/" + id, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async changeSyncStatusSuccess(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/syncstatus/id/" + id, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async resendToKitchen(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/resendkitchen/id/" + id, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async refund(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/refund/id/" + id, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async getManuelPayment(id, paymentType) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/payment/id/" + id + "/paymentType/" + paymentType, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async displayOrders(pagenumber) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/displayOrders/" + pagenumber, {
            headers: { 'Content-Type': 'application/json', 'X-Softrame-BranchId': localStorage.getItem("merchantBranchId") },
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async getSummary(startDate,endDate, clientAgent) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/summary/" +startDate + "/" + endDate + "/" +clientAgent, {
            crossDomain: true,
            method: 'get',
            headers: {'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"), 'Content-Type': 'application/json'}
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async getOrdersForKitchen() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/displayOrdersForKitchen", {
            headers: { 'Content-Type': 'application/json', 'X-Softrame-BranchId': localStorage.getItem("merchantBranchId") },
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }


}